import { render, staticRenderFns } from "./zhuanzhang.vue?vue&type=template&id=54f5c73b&"
import script from "./zhuanzhang.vue?vue&type=script&lang=js&"
export * from "./zhuanzhang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports